import React from 'react'
import { useNavigate } from 'react-router-dom'

function Home() {
  const navigate = useNavigate()

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Welcome to CuvrIQ</h1>
      <p>Select an option to continue.</p>
      <button onClick={() => navigate('/dashboard')}>Go to Dashboard</button>
    </div>
  )
}

export default Home
